<template>
  <div>
    <FormCol field="receipt" :showLabel="false">
      <div v-if="gateways">
        <FormLabel class="radio-inline" v-if="gateways.USReceipt" for="currency-usd">
            <input type="radio" name="currency" id="currency-usd" :checked="form.gateway == gateways.USReceipt" @click="setValue('gateway', gateways.USReceipt)"> US Receipt
        </FormLabel>
        <FormLabel class="radio-inline" v-if="gateways.CAReceipt" for="currency-cad">
            <input type="radio" name="currency" id="currency-cad" :checked="form.gateway == gateways.CAReceipt" @click="setValue('gateway', gateways.CAReceipt)"> Canadian Receipt
        </FormLabel>
        <FormLabel class="radio-inline" v-if="gateways.ILReceipt" for="currency-il">
            <input type="radio" name="currency" id="currency-il" :checked="form.gateway == gateways.ILReceipt" @click="setValue('gateway', gateways.ILReceipt)"> Israeli Receipt
        </FormLabel>
          <div class="hebrew__tax" v-if="showHebrew && form.gateway == gateways.ILReceipt">התרומה מוכרת <b>לצרכי מס</b>&nbsp;לפי סעיף 46
        </div>
      </div>
    </FormCol>
    <FormRow v-if="gateways && form.gateway == gateways.ILReceipt" inline class="israeli-tax-id-row">
      <FormCol field="taxId" label="Teudat Zehut" placeholder="Enter your Teudat Zehut" />
    </FormRow>
  </div>
</template>
<script setup lang="ts">
import { usePaymentForm } from '~/shared/use-payment-form'
import { watch } from 'vue'

defineProps<{
  receipts?: Array<'canadian' | 'us' | 'israel'>
  showHebrew?: boolean
}>()

const { setValue, form, gateways, setTouched } = usePaymentForm()

watch(() => form.value.currency, () => {
  setTouched('receipt')
})

watch(() => form.value.currency, (currency) => {
  if (currency == 'USD') {
    setValue('gateway', gateways.value.USReceipt)
  } else if (currency == 'CAD') {
    setValue('gateway', gateways.value.CAReceipt)
  } else if (currency == 'ILS') {
    setValue('gateway', gateways.value.ILReceipt)
  }
})
</script>

<style scoped lang="scss">
.hebrew__tax {
  margin-top: 5px;
  font-size: 14px;
  font-style: italic;
}
.israeli-tax-id-row {
  margin-top: 10px;
}
</style>